export default __webpack_public_path__ + "static/media/breakfastHealthgenom.61027719.svg";